import { render, staticRenderFns } from "./ApprovalForms.vue?vue&type=template&id=11be5d6a&scoped=true&"
import script from "./ApprovalForms.vue?vue&type=script&lang=js&"
export * from "./ApprovalForms.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalForms.vue?vue&type=style&index=0&id=11be5d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be5d6a",
  null
  
)

export default component.exports